import React, { useState, useEffect, useRef } from 'react';
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { Container, Row, Col } from 'reactstrap';


const renderContent = (content) => {
    return { __html: content };
}

function EirLeftMenuRightContent(props) {
    let parentRef = props.parentContent;
    let getParentFolder = props.folderName;
    let parentContentArray = [];
    let getCount = getParentFolder.split("/");
    Object.values(parentRef).forEach(value => {
        parentContentArray.push({ "filepath": value.fileName, "displayname": value.displayName });
    });
    let firstChildArray = [];
    for (var i = 0; i < parentContentArray.length; i++) {
        if (getCount.length + 1 == parentContentArray[i].filepath.split("/").length) firstChildArray.push(parentContentArray[i]);
    }

    useEffect(() => {
    })
    return (
        <div className="container" id={"eir-leftmenu-" + props.Occurence}>
            <div className="col-12 row">
                <div>
                    {
                        firstChildArray.map((name, ind) => (
                            <div key={ind}>
                                <h4><a href={name.filepath}>{name.displayname} </a></h4>
                                {
                                    parentContentArray.map((sub, subindex) =>
                                        ((sub.filepath != name.filepath) && (sub.filepath.indexOf(name.filepath) > -1)) ?
                                            <li key={subindex}><a href={sub.filepath}>{sub.displayname}</a></li> : ''
                                    )

                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}
export default EirLeftMenuRightContent;